import { SVGProps } from 'react';

const IcCalender = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.00008 2.33329V1.66663H5.33342V2.33329H10.6667V1.66663H12.0001V2.33329H13.3334C13.8857 2.33329 14.3334 2.78101 14.3334 3.33329V13.3333C14.3334 13.8856 13.8857 14.3333 13.3334 14.3333H2.66675C2.11446 14.3333 1.66675 13.8856 1.66675 13.3333V3.33329C1.66675 2.78101 2.11446 2.33329 2.66675 2.33329H4.00008ZM4.00008 3.66663H3.00008V6.66663H13.0001V3.66663H12.0001V4.33329H10.6667V3.66663H5.33342V4.33329H4.00008V3.66663ZM13.0001 7.99996H3.00008V13H13.0001V7.99996Z'
        fill='#566A7F'
      />
    </svg>
  );
};

export default IcCalender;
